import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { JSX } from 'react';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

const EntryListRoot = styled('ul', { name: 'EntryListRoot' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  listStyle: 'none',
  padding: 0,
  margin: 0,
  marginTop: theme.spacing(42),
}));

const EntryListContentListListItem = styled('li', { name: 'EntryListContentListListItem' })(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const EntryListContentListLabel = styled('div', { name: 'EntryListContentListLabel' })(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(6),
    alignItems: 'center',
  }),
);

const EntryListWidgetEntry = ({ label, value }: any) => {
  return (
    <EntryListContentListListItem>
      <EntryListContentListLabel>
        <Typography variant="text2" color={'text.secondary'}>
          {label}
        </Typography>
      </EntryListContentListLabel>
      <Typography variant="text1">{toLocaleBrowserSettings(value)}</Typography>
    </EntryListContentListListItem>
  );
};

type Entry = {
  label: string;
  value: number;
};

type EntryListWidgetListProps = {
  entries: Entry[];
};

export const WidgetEntryList = ({ entries }: EntryListWidgetListProps) => {
  return (
    <EntryListRoot>
      {entries.map((props) => (
        <EntryListWidgetEntry {...props} key={props.label} />
      ))}
    </EntryListRoot>
  );
};

const EntryListSuspenseSkeletonEntry = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(20),
}));

export const WidgetEntryListSuspenseFallback = ({ rowsCount }: { rowsCount: number }) => {
  const skeletons: JSX.Element[] = [];
  for (let i = 1; i <= rowsCount; i++) {
    skeletons.push(
      <EntryListContentListListItem>
        <EntryListSuspenseSkeletonEntry />
      </EntryListContentListListItem>,
    );
  }

  return <EntryListRoot>{skeletons}</EntryListRoot>;
};
